import { z } from 'zod';

export type ResetGameSettingsResponse = {
	accountId: number;
	accountGameSettingsId: number;
};

export const resetGameSettingsResponseSchema = z.object({
	accountId: z.number(),
	accountGameSettingsId: z.number(),
});
